import React, { useState } from 'react';
import { DataModel as DataModelType } from '../data/dataModels';
import { apiEndpoints } from '../data/apiEndpoints';
import './DataModel.css';

interface DataModelProps {
  model: DataModelType;
}

const DataModelCard: React.FC<DataModelProps> = ({ model }) => {
  const [expanded, setExpanded] = useState(false);

  const relatedEndpoints = model.usedByEndpoints
    .map(id => apiEndpoints.find(ep => ep.id === id))
    .filter((ep): ep is NonNullable<typeof ep> => Boolean(ep));

  return (
    <div className="data-model">
      <div className="data-model-header" onClick={() => setExpanded(!expanded)}>
        <div className="data-model-main">
          <span className="data-model-name">{model.name}</span>
        </div>
        <button className="expand-button">{expanded ? '−' : '+'}</button>
      </div>

      {expanded && (
        <div className="data-model-body">
          <p className="data-model-description">{model.description}</p>

          <h4>Fields</h4>
          <table className="parameters-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {model.fields.map(field => (
                <tr key={field.name}>
                  <td><code>{field.name}</code></td>
                  <td><span className="type-badge">{field.type}</span></td>
                  <td>{field.description}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <h4>Example</h4>
          <pre className="response-example">{model.example}</pre>

          {relatedEndpoints.length > 0 && (
            <>
              <h4>Used By Endpoints</h4>
              <div className="related-endpoints">
                {relatedEndpoints.map(ep => (
                  <a key={ep.id} href={`#endpoint-${ep.id}`} className="related-endpoint-link">
                    <span className="method-chip">{ep.method}</span> {ep.path}
                  </a>
                ))}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default DataModelCard;
